// GetRemoteConfigDataWithTimeout.jsx
import React from 'react';
import PropTypes from 'prop-types';

const RECOMMEND_MESSAGE_CATEGORY_TIMEOUT = 5 * 1000; // TODO: remote config

export class GetRemoteConfigDataWithTimeout extends React.PureComponent {
  recommendFlixCategoryTimer = null;
  recommendStoryCategoryTimer = null;
  searchSwaggerOnlineTimer = null;
  searchSwaggerNewTimer = null;
  updateRecommendFlixCategory = () => {
    const {
      flixDetailRecommendFlixCategory,
      searchRecommendFlixCategory,
      updateRecommendFlixCategory,
    } = this.props;
    clearTimeout(this.updateRecommendFlixCategory);
    updateRecommendFlixCategory({
      flixDetail: flixDetailRecommendFlixCategory,
      search: searchRecommendFlixCategory,
    });
  };
  updateRecommendStoryCategory = () => {
    const { searchRecommendStoryCategory, updateRecommendStoryCategory } =
      this.props;
    clearTimeout(this.updateRecommendStoryCategory);
    updateRecommendStoryCategory({
      search: searchRecommendStoryCategory,
    });
  };
  updateSwaggerOnlineFeed = () => {
    const { searchSwaggerOnlineFeed, updateSwaggerOnlineFeed } = this.props;
    clearTimeout(this.updateSwaggerOnlineFeed);
    updateSwaggerOnlineFeed({
      search: searchSwaggerOnlineFeed,
    });
  };
  updateSwaggerNewFeed = () => {
    const { searchSwaggerNewFeed, updateSwaggerNewFeed } = this.props;
    clearTimeout(this.updateSwaggerNewFeed);
    updateSwaggerNewFeed({
      search: searchSwaggerNewFeed,
    });
  };
  componentDidMount() {
    const {
      flixDetailRecommendFlixCategory,
      searchRecommendFlixCategory,
      searchRecommendStoryCategory,
      searchSwaggerOnlineFeed,
      searchSwaggerNewFeed,
    } = this.props;
    if (flixDetailRecommendFlixCategory || searchRecommendFlixCategory) {
      this.updateRecommendFlixCategory();
    } else {
      this.recommendFlixCategoryTimer = setTimeout(
        this.updateRecommendFlixCategory,
        RECOMMEND_MESSAGE_CATEGORY_TIMEOUT
      );
    }
    if (searchRecommendStoryCategory) {
      this.updateRecommendStoryCategory();
    } else {
      this.recommendStoryCategoryTimer = setTimeout(
        this.updateRecommendStoryCategory,
        RECOMMEND_MESSAGE_CATEGORY_TIMEOUT
      );
    }
    if (searchSwaggerOnlineFeed) {
      this.updateSwaggerOnlineFeed();
    } else {
      this.searchSwaggerOnlineTimer = setTimeout(
        this.updateSwaggerOnlineFeed,
        RECOMMEND_MESSAGE_CATEGORY_TIMEOUT
      );
    }
    if (searchSwaggerNewFeed) {
      this.updateSwaggerNewFeed();
    } else {
      this.searchSwaggerNewTimer = setTimeout(
        this.updateSwaggerNewFeed,
        RECOMMEND_MESSAGE_CATEGORY_TIMEOUT
      );
    }
  }
  componentDidUpdate(prevProps) {
    const {
      flixDetailRecommendFlixCategory: prevFlixDetailRecommendFlixCategory,
      searchRecommendFlixCategory: prevSearchRecommendFlixCategory,
      searchRecommendStoryCategory: prevSearchRecommendStoryCategory,
      searchSwaggerOnlineFeed: prevSearchSwaggerOnlineFeed,
      searchSwaggerNewFeed: prevSearchSwaggerNewFeed,
    } = prevProps;
    const {
      flixDetailRecommendFlixCategory,
      searchRecommendFlixCategory,
      searchRecommendStoryCategory,
      searchSwaggerOnlineFeed,
      searchSwaggerNewFeed,
    } = this.props;
    const shouldUpdateRecommendFlixCategory =
      (flixDetailRecommendFlixCategory &&
        prevFlixDetailRecommendFlixCategory !==
          flixDetailRecommendFlixCategory) ||
      (searchRecommendFlixCategory &&
        prevSearchRecommendFlixCategory !== searchRecommendFlixCategory);
    const shouldUpdateRecommendStoryCategory =
      searchRecommendStoryCategory !== prevSearchRecommendStoryCategory;
    const shouldUpdateSwaggerOnlineFeed =
      searchSwaggerOnlineFeed !== prevSearchSwaggerOnlineFeed;
    const shouldUpdateSwaggerNewFeed =
      searchSwaggerNewFeed !== prevSearchSwaggerNewFeed;
    if (shouldUpdateRecommendFlixCategory) {
      this.updateRecommendFlixCategory();
    }
    if (shouldUpdateRecommendStoryCategory) {
      this.updateRecommendStoryCategory();
    }
    if (shouldUpdateSwaggerOnlineFeed) {
      this.updateSwaggerOnlineFeed();
    }
    if (shouldUpdateSwaggerNewFeed) {
      this.updateSwaggerNewFeed();
    }
  }
  componentWillUnmount() {
    clearTimeout(this.updateRecommendFlixCategory);
    clearTimeout(this.updateRecommendStoryCategory);
    clearTimeout(this.updateSwaggerOnlineFeed);
    clearTimeout(this.updateSwaggerNewFeed);
  }
  render() {
    return null;
  }
}

GetRemoteConfigDataWithTimeout.propTypes = {
  flixDetailRecommendFlixCategory: PropTypes.string,
  searchRecommendFlixCategory: PropTypes.string,
  searchRecommendStoryCategory: PropTypes.string,
  searchSwaggerOnlineFeed: PropTypes.string,
  searchSwaggerNewFeed: PropTypes.string,
  updateRecommendFlixCategory: PropTypes.func,
  updateRecommendStoryCategory: PropTypes.func,
  updateSwaggerOnlineFeed: PropTypes.func,
  updateSwaggerNewFeed: PropTypes.func,
};

GetRemoteConfigDataWithTimeout.defaultProps = {
  flixDetailRecommendFlixCategory: null,
  searchRecommendFlixCategory: null,
  searchRecommendStoryCategory: null,
  searchSwaggerOnlineFeed: null,
  searchSwaggerNewFeed: null,
  updateRecommendFlixCategory: () => null,
  updateRecommendStoryCategory: () => null,
  updateSwaggerOnlineFeed: () => null,
  updateSwaggerNewFeed: () => null,
};

export default GetRemoteConfigDataWithTimeout;
